/**
 * Hook for managing drop indicator state during drag operations
 */
import { useState, useCallback } from "react"

export interface DropPosition {
  nodeKey: React.Key
  position: "before" | "after" | "inside"
}

interface UseDropIndicatorReturn {
  dropPosition: DropPosition | null
  setDropPosition: (position: DropPosition | null) => void
  updateDropPosition: (nodeKey: React.Key, position: "before" | "after" | "inside") => void
  clearDropPosition: () => void
}

/**
 * Custom hook to manage drop indicator state
 * @returns Drop position state and update functions
 */
export const useDropIndicator = (): UseDropIndicatorReturn => {
  const [dropPosition, setDropPosition] = useState<DropPosition | null>(null)

  const updateDropPosition = useCallback((nodeKey: React.Key, position: "before" | "after" | "inside") => {
    setDropPosition({ nodeKey, position })
  }, [])

  const clearDropPosition = useCallback(() => {
    setDropPosition(null)
  }, [])

  return {
    dropPosition,
    setDropPosition,
    updateDropPosition,
    clearDropPosition,
  }
}
